<template>
  <div style=" color: #666;overflow: hidden;">
    <div class="style-row">
      <Checkbox v-model="customerImageButton" :binary="true" style="margin-right: 10px"/>
      <label for="label">Customer Image Upload Button</label>
    </div>
    <div v-if="customerImageButton">
      <div class="style-row">
        <label for="label">Button Text</label>
        <InputText type="text" v-model="customerImageButtonText" style="margin-left: 20px;width:200px;"/>
      </div>
      <div class="style-row">
        <label for="label">Button Color</label>
        <ColorButton @click="btnBgColorPickerVisible.toggle($event)" :color="customerImageButtonColor" style="margin-left: 15px;width:200px;" />
        <OverlayPanel ref="btnBgColorPickerVisible">
          <ColorPicker v-model="customerImageButtonColor"
                       @edit-theme="$refs.btnBgColorPickerVisible.toggle(false); themeDialogVisible = true"
          />
        </OverlayPanel>
      </div>
      <div class="style-row">
        <label for="label">Button Notes</label>
        <InputText type="text" v-model="customerImageButtonNotes" style="margin-left: 15px;width:200px;"/>
      </div>
    </div>

    <div class="style-row">
      <label for="label" :style="{ color: customerImageButton ? '#ccc' : '#666' }">Select Existing Image</label>
      <Dropdown v-model="selectedCustomerImage" :options="customerImages" optionLabel="notes" optionValue="widgetId" :disabled="customerImageButton" style="margin-left: 15px;width: 160px;" />

    </div>
  </div>

</template>
<script setup lang="ts">
import {computed, ref} from 'vue'
import {useCustomerStore, useWidgetStore, useMainStore} from "@/store";
import {storeToRefs} from "pinia";
import ColorButton from "@/views/Editor/Toolbar/common/ColorButton.vue";
import ColorPicker from "@/components/ColorPicker/index.vue";

const widgetStore = useWidgetStore()
const { themeDialogVisible } = storeToRefs(useMainStore())
const {selectedWidget} = storeToRefs(widgetStore)
const customerStore = useCustomerStore()
const { customerImages } = storeToRefs(customerStore)

const btnBgColorPickerVisible = ref()

const selectedCustomerImage = computed({
  get() {
    return selectedWidget.value?.customerImageButtonWidgetId ?? ''
  },
  set(val) {
    selectedWidget.value.customerImageButtonWidgetId = val
  }
})

const customerImageButton = computed({
  get() {
    return selectedWidget.value?.customerImageButton?.button ?? false
  },
  set(val) {
    if (val) {
      selectedWidget.value.subType = 'customer_image_button'
      customerStore.setUpImage(selectedWidget.value.id)
    }
    else {
      selectedWidget.value.subType = 'out_text'
      customerStore.removeImage(selectedWidget.value.id)
    }

    if (!selectedWidget.value?.customerImageButton) {
      selectedWidget.value.customerImageButton = {
        button: val,
        text: '',
        color: '',
        notes: ''
      }
    } else if (selectedWidget.value.customerImageButton) selectedWidget.value.customerImageButton.button = val
  }
})

const customerImageButtonText = computed({
  get() {
    return selectedWidget.value?.customerImageButton?.text ?? ''
  },
  set(val) {
    if (selectedWidget.value?.customerImageButton) selectedWidget.value.customerImageButton.text = val
  }
})

const customerImageButtonColor = computed({
  get() {
    return selectedWidget.value?.customerImageButton?.color ?? 'transparent';
  },
  set(val) {
    if (selectedWidget.value?.customerImageButton) selectedWidget.value.customerImageButton.color = val
  }
})

const customerImageButtonNotes = computed({
  get() {
    return selectedWidget.value?.customerImageButton?.notes ?? ''
  },
  set(val) {
    if (selectedWidget.value?.customerImageButton) {
      selectedWidget.value.customerImageButton.notes = val
      customerStore.updateImage(selectedWidget.value.id, { notes: val })
    }
  }
})


</script>

<style scoped>
.style-row { margin-top: 15px; width: 300px; align-items: center; display: flex  }
:deep(.p-inputtext) {
  text-align: left !important;
}
</style>
